import React from 'react';

import I18n from '@module/i18n';
import Icon from '@component/icon';
import LanguagePicker from '@component/languagepicker';

import { ABBEY } from '@constant/colors';

export const Footer = () => (
  <footer className="footer">
    <div className="footer__menu">
      <Icon className="footer__logo" type="Logo" width={33} color={ABBEY} />
      <LanguagePicker />
      <nav className="footer__nav">
        <a
          title={I18n.t('panel.footer.terms')}
          href="/legal/terms"
          data-route-context="about"
          className="footer__link"
        >
          {I18n.t('panel.footer.terms')}
        </a>
        <a
          title={I18n.t('panel.footer.press')}
          href={I18n.t('external_links.prco')}
          rel="external"
          className="footer__link"
        >
          {I18n.t('panel.footer.press')}
        </a>
        <a
          title={I18n.t('panel.footer.jobs')}
          href={I18n.t('external_links.homerun')}
          rel="external"
          className="footer__link"
        >
          {I18n.t('panel.footer.jobs')}
        </a>
      </nav>
    </div>
    <div className="footer__social-links">
      <a
        title={I18n.t('panel.footer.twitter')}
        href={I18n.t('external_links.twitter')}
        rel="external"
        className="footer__social-link"
      >
        <Icon type="Twitter" width={20} />
      </a>
      <a
        title={I18n.t('panel.footer.facebook')}
        href={I18n.t('external_links.facebook')}
        rel="external"
        className="footer__social-link"
      >
        <Icon type="Facebook" width={20} />
      </a>
      <a
        title={I18n.t('panel.footer.instagram')}
        href={I18n.t('external_links.instagram')}
        rel="external"
        className="footer__social-link"
      >
        <Icon type="Instagram" width={20} />
      </a>
      <a
        title={I18n.t('panel.footer.youtube')}
        href={I18n.t('external_links.youtube')}
        rel="external"
        className="footer__social-link"
      >
        <Icon type="Youtube" width={20} />
      </a>
    </div>
  </footer>
);

export default Footer;
